import {
  addNavMenuItem,
  registerBulkAction,
  ModalService,
  NotificationService,
  DataService,
  registerFormInputComponent,
  I18nService,
} from "@bb-vendure/admin-ui/core";
import { forkJoin, take } from "rxjs";
import { DeleteRetailDocument } from "./generated-graphql/graphql";

export default [
  // Add your providers here
  addNavMenuItem(
    {
      id: "retailer",
      label: "nav.retailer",
      icon: "store",
      routerLink: ["/extensions/retailer"],
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadRetailer");
      },
    },
    "products-section"
  ),
  registerBulkAction({
    location: "retail-list",
    label: "bulk-action.delete-retailer",
    icon: "trash",
    iconClass: "is-danger",
    requiresPermission: (userPermissions) =>
      userPermissions.includes("DeleteRetailer"),
    onClick: ({ injector, selection, clearSelection, hostComponent }) => {
      const modalService = injector.get(ModalService);
      const dataService = injector.get(DataService);
      const translator = injector.get(I18nService);
      const noti = injector.get(NotificationService);
      const body = translator.translate("bulk-action.delete-retailer-dialog", {
        count: selection.length,
      });
      modalService
        .dialog({
          title: "bulk-action.delete-retailer",
          body,
          buttons: [
            { label: "common.cancel", type: "secondary" },
            { label: "common.delete", type: "danger", returnValue: true },
          ],
        })
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            const deleteObservables = selection.map((item) =>
              dataService.mutate(DeleteRetailDocument, { id: item.id })
            );

            forkJoin(deleteObservables).subscribe((res) => {
              console.log(res);
              let deletedCount = 0;
              res.forEach((r) => {
                const { deleteRetail } = r;
                if (deleteRetail.result === "DELETED") {
                  deletedCount++;
                } else if (deleteRetail.result === "NOT_DELETED") {
                  noti.error(
                    translator.translate("bulk-action.failed-delete-retailer", {
                      id: deleteRetail.message,
                    })
                  );
                }
                if (deletedCount > 0) {
                  noti.success(
                    translator.translate("bulk-action.deleted-retailer", {
                      count: deletedCount,
                    })
                  );
                }
              });
              hostComponent.refresh();
              clearSelection();
            });
          }
        });
    },
  }),

  //registerFormInputComponent("retailer-dropdown", RetailerDropdownComponent),
];
